module.exports = __webpack_public_path__ + "img/military.e3f3158e.png";